/**
 * Generate a non-secure hash code from a string, as a string
 *
 * See: https://stackoverflow.com/a/8831937
 *
 * Note: The addition of `Math.abs()` reduces the uniqueness of the generated hash, compared
 *   to the implementation without (from StackOverflow). However, since our most common
 *   use-case is generating a string to use as an HTML identifier, we don't want strings
 *   starting with dashes. While technically valid HTML5, <div id="-123" /> isn't ideal.
 */
function hashString(str) {
  var hash = 0;

  if (str.length == 0) {
    return Math.abs(hash).toString();
  }

  for (var i = 0; i < str.length; i++) {
    var char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  return Math.abs(hash).toString();
}

export default hashString;
//# sourceMappingURL=hashString.js.map
